import { useState, useEffect } from 'react';

function CountdownTimer({ targetDate }) {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = new Date(targetDate) - new Date();

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <div data-testid="countdown-timer" className="flex justify-center gap-6 py-8">
      <div className="flex flex-col items-center">
        <div className="font-mono text-4xl md:text-6xl font-bold text-[#E11D48] tabular-nums">
          {String(timeLeft.days).padStart(2, '0')}
        </div>
        <div className="text-xs text-zinc-500 uppercase tracking-widest mt-2">
          Days
        </div>
      </div>
      <div className="text-4xl text-[#E11D48] self-start mt-1">:</div>
      <div className="flex flex-col items-center">
        <div className="font-mono text-4xl md:text-6xl font-bold text-[#E11D48] tabular-nums">
          {String(timeLeft.hours).padStart(2, '0')}
        </div>
        <div className="text-xs text-zinc-500 uppercase tracking-widest mt-2">
          Hours
        </div>
      </div>
      <div className="text-4xl text-[#E11D48] self-start mt-1">:</div>
      <div className="flex flex-col items-center">
        <div className="font-mono text-4xl md:text-6xl font-bold text-[#E11D48] tabular-nums">
          {String(timeLeft.minutes).padStart(2, '0')}
        </div>
        <div className="text-xs text-zinc-500 uppercase tracking-widest mt-2">
          Mins
        </div>
      </div>
      <div className="text-4xl text-[#E11D48] self-start mt-1">:</div>
      <div className="flex flex-col items-center">
        <div className="font-mono text-4xl md:text-6xl font-bold text-[#E11D48] tabular-nums">
          {String(timeLeft.seconds).padStart(2, '0')}
        </div>
        <div className="text-xs text-zinc-500 uppercase tracking-widest mt-2">
          Secs
        </div>
      </div>
    </div>
  );
}

export default CountdownTimer;
